module.exports = __webpack_public_path__ + "vrapplication-39bb593c.webp";